import universal from 'react-universal-component';
import universalImport from 'babel-plugin-universal-import/universalImport';
import path from 'path';
import { timeout } from '../../lazy/lazyConstants';

/* istanbul ignore next */
export default universal(
    universalImport({
        chunkName: () => 'UrgencyMessage',
        path: () => path.join(__dirname, './UrgencyMessage'),
        resolve: () => require.resolveWeak('./UrgencyMessage'),
        load: () =>
            Promise.all([import(/* webpackChunkName: "UrgencyMessage" */ './UrgencyMessage')]).then(
                (proms) => proms[0]
            ),
    }),
    {
        loading: () => null,
        error: () => null,
        timeout,
    }
);
